// [frontend/src/components/ContentPromptEditor.jsx](frontend/src/components/ContentPromptEditor.jsx)
import { useState, useEffect } from 'react';

function ContentPromptEditor({ feedbackPrompt, onUpdate }) {
  const [prompt, setPrompt] = useState(feedbackPrompt);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Synchronize local prompt state with feedbackPrompt prop
  useEffect(() => {
    setPrompt(feedbackPrompt);
  }, [feedbackPrompt]);

  const handleSave = () => {
    setLoading(true);
    onUpdate(prompt)
      .then(() => setLoading(false))
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <div>
      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        className="w-full p-2 border rounded mb-4"
        rows={30}
      />
      {error && <p className="text-red-500 mb-2">{error}</p>}
      <button
        onClick={handleSave}
        className="bg-black text-white px-4 py-2 rounded"
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save Prompt'}
      </button>
    </div>
  );
}

export default ContentPromptEditor;